import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_BRANDING = {
  product_name: "Qenqo",
  tagline: "Find care near you",
  logo_url: "/favicon.png",
  favicon_url: "/favicon.png",
  primary_color: "#214D3A",
  accent_color: "#C57053",
  support_email: "info.queuemed@gmail.com",
  support_phone: "+917006021273",
  footer_text: "Find care near you.",
  powered_by_text: "Powered by Qenqo",
  email_sender_name: "Qenqo",
};

let cachedBranding = null;

export function useBranding() {
  const [branding, setBranding] = useState(cachedBranding || DEFAULT_BRANDING);

  useEffect(() => {
    let mounted = true;
    api.get("/platform/branding")
      .then(({ data }) => {
        cachedBranding = { ...DEFAULT_BRANDING, ...data };
        if (mounted) setBranding(cachedBranding);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  return branding;
}
